(function () {
  // Minimal Shopify money_format formatter — mirrors the {{ amount }} /
  // {{ amount_no_decimals }} / {{ amount_with_comma_separator }} placeholders
  // so the count-up animation matches the store's real currency formatting,
  // not a hardcoded $.
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;

    var negative = number < 0 ? '-' : '';
    var n = Math.abs(number).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return negative + dollars + cents;
  }

  function formatMoney(cents, format) {
    format = format || window.MB_ILM_MONEY_FORMAT || '${{amount}}';
    var value = cents / 100;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return format;

    var formatted;
    switch (match[1]) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2);
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2);
    }
    return format.replace(placeholderRegex, formatted);
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-ilm-amount')) || 0;
    var duration = parseInt(el.getAttribute('data-ilm-duration'), 10) || 1400;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      el.textContent = formatMoney(Math.round(current * 100));
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatMoney(Math.round(target * 100));
      }
    }
    requestAnimationFrame(step);
  }

  // At narrower widths this theme leaves body/html scrollable (window fires
  // 'scroll'); at wider desktop widths (>=990px) it switches body/html to
  // overflow:hidden and makes .page-wrapper the real scrolling element
  // instead, so window never fires 'scroll' there — listening on both
  // covers either case (same fix as mecca-header.js/mecca-pdp-main.js).
  function initCounters() {
    var counters = document.querySelectorAll('[data-mb-ilm-count]');
    if (!counters.length) return;

    function maybeCount() {
      counters.forEach(function (el) {
        if (el._mbIlmDone) return;
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.88 && rect.bottom > 0) {
          el._mbIlmDone = true;
          countUp(el);
        }
      });
    }
    maybeCount();
    var pageScroller = document.querySelector('.page-wrapper');
    window.addEventListener('scroll', maybeCount, { passive: true });
    if (pageScroller) pageScroller.addEventListener('scroll', maybeCount, { passive: true });
    window.addEventListener('resize', maybeCount, { passive: true });
  }

  function initMap(mapEl) {
    var noteScript = mapEl.querySelector('[data-mb-ilm-notes]');
    var noteEl = mapEl.querySelector('[data-mb-ilm-note]');
    if (!noteScript || !noteEl) return;

    var notes;
    try {
      notes = JSON.parse(noteScript.textContent) || [];
    } catch (e) {
      notes = [];
    }
    if (!notes.length) {
      noteEl.style.display = 'none';
      return;
    }

    var stateEl = noteEl.querySelector('.mb-ilm__note-state');
    var bookEl = noteEl.querySelector('.mb-ilm__note-book');
    var coverEl = noteEl.querySelector('.mb-ilm__note-cover');
    var i = -1;

    function show() {
      i = (i + 1) % notes.length;
      var note = notes[i];
      if (stateEl) stateEl.textContent = note.state;
      if (bookEl) bookEl.textContent = note.book;
      if (coverEl) {
        coverEl.innerHTML = note.image
          ? '<img src="' + note.image + '" alt="" loading="lazy" width="48" height="48">'
          : '';
      }
    }

    show();
    if (notes.length > 1) {
      setInterval(function () {
        noteEl.classList.add('mb-ilm--swap');
        setTimeout(function () {
          show();
          noteEl.classList.remove('mb-ilm--swap');
        }, 500);
      }, 3800);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCounters();
    document.querySelectorAll('[data-mb-ilm-map]').forEach(initMap);
  });
})();